import { InternalAxiosRequestConfig } from 'axios';

export default function requestInterceptor(
    config: InternalAxiosRequestConfig
): InternalAxiosRequestConfig {
    if (typeof window !== 'undefined') {

        const token = localStorage.getItem('accessToken'),
            idUserLogado = localStorage.getItem('idUserLogado'),
            idCompany = localStorage.getItem('idCompany');

        if (token) {
            adicionaToken(config, token, idUserLogado || "", idCompany || "");
        }
    }
    
    return config;
}

function adicionaToken(request: InternalAxiosRequestConfig, token: string, idUserLogado: string, idCompany: string): void {
    if (request.headers && typeof request.headers.set === 'function') {
        request.headers.set('Content-Type', 'application/json');
        request.headers.set('Authorization', `Bearer ${token}`);
        request.headers.set("x-user", idUserLogado);
        request.headers.set("x-company", idCompany);
    }
}
